import { WorkspaceSignUpFormRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The `sign-up-forms_` (trailing underscore) segment keeps this route OUT of
// the Outlet-less `sign-up-forms.tsx` list route, whose component would
// otherwise render in place of this one.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/sign-up-forms_/$id')({
  component: WorkspaceSignUpFormRoute,
});
